import { mapGetters, mapMutations } from "vuex";
import StarRating from "vue-star-rating";

export default {
    name: "new-collection-item",
    props: ["item"],
    computed: {
        ...mapGetters({}),
    },
    components: {
        StarRating,
    },
    methods: {
        ...mapMutations({}),
    },
};
